// src/hooks/useTranslations.js
import { useTranslation } from 'react-i18next';

export const useTranslations = () => {
    const { t, i18n } = useTranslation();

    // Remove the useEffect that calls reloadResources
    // Only reload if explicitly needed, not on every component mount

    return { t, i18n };
};
